export const ACCESSOR_SIZE = 52;
export const ACTIONS_SIZE = 124;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - ACTIONS_SIZE - ACCESSOR_SIZE) * percent;
};

export const getColumns = (totalWidth?: number) => [
  {
    accessorKey: 'avatar',
    header: '',
    size: ACCESSOR_SIZE,
    accessory: true,
  },
  {
    accessorKey: 'name',
    header: 'Service',
    minSize: 64,
    size: getColumnSize(0.5, totalWidth),
    sx: { pl: 0 },
    enableResizing: true,
  },
  {
    accessorKey: 'info',
    header: 'Description',
    size: getColumnSize(0.5, totalWidth),
    minSize: 52,
    enableResizing: true,
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
  {
    accessorKey: 'options',
    size: ACTIONS_SIZE,
  },
];
